module.exports = __webpack_public_path__ + "static/img/3.0a1d8f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/3.png
// module id = wByu
// module chunks = 0